const Sections = {
  INITIAL: 'initial',
  LOADER: 'loader',
};

const SectionsURLs = {
  INITIAL: '/initial',
  LOADER: '/loader',
};

export { Sections, SectionsURLs };
